function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22 14.3315V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V14.3315C2 14.112 2.03614 13.894 2.10698 13.6862L5.28819 4.35465C5.56435 3.54458 6.32535 3 7.18121 3H16.8188C17.6746 3 18.4356 3.54457 18.7118 4.35465L21.893 13.6862C21.9639 13.894 22 14.112 22 14.3315ZM8.67756 8H15.3224C15.7316 8 16.0995 8.24927 16.2512 8.62928L18.5 14.2632H15.5C15.5 14.2632 14.6562 16.5 12 16.5C9.34375 16.5 8.5 14.2632 8.5 14.2632H5.5L7.74882 8.62928C7.9005 8.24927 8.26839 8 8.67756 8Z"
});

var SvgInbox = function SvgInbox(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInbox, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/inbox.60d96189.svg";
export { ForwardRef as ReactComponent };